module.exports = __webpack_public_path__ + "img/truck-fleeet.9de79140.svg";